import { Dimensions, StyleSheet } from 'react-native'
import { colorList } from 'utils/colors'
import { ThemedValues, ThemedShared } from 'styles/themed'
import { layoutStyles } from 'styles/layout'
import HelperPlatform from 'utils/helper-platform'

export const styles = StyleSheet.create( {
	
	webBlock: {
		flex: 1,
		alignSelf: 'center',
		width: '100%',
		maxWidth: 600,
		height: '100%',
		// marginBottom: 32,
		// marginTop: 32
	},
	
	headerTitle: {
		color: colorList.TITLE.primary,
		fontSize: 28,
		marginTop: 8,
	},
	headerSubtitle: {
		color: colorList.TEXT.light,
		fontSize: 15,
		marginTop: 4,
		textAlign: 'center',
	},
	headerTitleDark: {
		// padding: ThemedShared.paddingSmall.padding,
		color: colorList.BLACK.primary,
	},

	icon: {
		fontSize: 20
	},
	
	iconGrey: {
		color: colorList.GREY.dark
	},
	iconGreen: {
		color: colorList.GREEN.primary
	},
	iconOrange: {
		color: colorList.ORANGE.primary
	},
	
	iconRed: {
		color: colorList.RED.primary
	},
	
	overlayGradient: {
		position: 'absolute',
		left: 0,
		right: 0,
		top: 0,
		bottom: 0,
	},
	
	successContainer:{
		position: 'absolute',
		left: 0,
		right: 0,
		top: 0,
		bottom: 0,
		flex: 1,
		justifyContent: 'center',
		alignItems: 'center',
	},
	successTextContainer: {
		justifyContent: 'center',
		alignItems: 'center',
		width: '100%',
		paddingTop: 20,
		paddingBottom: 20
	},
	iconSuccess: {
		fontSize: 120,
		color: colorList.TEXT.primary
	},
	textSuccess: {
		color: colorList.TEXT.primary
	},

	headerContainer: {
		alignItems: 'center',
		justifyContent: 'center',
	},
	headerImage: {
		height: 72,
		width: 72,
	},
	headerText: {
		fontSize: 20,
		fontWeight: '700',
	},
	
	itemsContainer: {
		margin: 0,
		paddingBottom: 0,
	},
	itemContainer: {
		marginTop: 16,
	},
	
	instructionsTextContainer: {
		padding: ThemedShared.paddingSmall.padding,
	},
	instructionsText: {
		color: HelperPlatform.isWeb() ? colorList.BLACK.primary : colorList.BLACK.primary,
		fontSize: 14,
	},
	
	outerContainer: {
		flex: 1,
		alignItems: 'center',
		justifyContent: 'center',
		paddingVertical: 32,
		paddingHorizontal: 16,
	},
	outerContainerMobile: {
		justifyContent: 'flex-start',
		paddingVertical: 16,
		paddingHorizontal: 12,
	},
	container: {
		paddingTop: 24,
		justifyContent: 'flex-start',
		maxWidth: 520,
		width: '100%',
	},
	authenticationCard: {
		...ThemedShared.shadowed,
		padding: 24,
		borderRadius: 16,
		backgroundColor: colorList.WHITE.primary,
		overflow: 'hidden',
	},
	authenticationCardMobile: {
		padding: 16,
	},
	
	errorContainer: {
		marginTop: 8,
		borderRadius: ThemedValues.borderRadius,
		paddingVertical: 10,
		paddingHorizontal: 12,
		backgroundColor: '#fff2f1',
		borderLeftWidth: 3,
		borderLeftColor: colorList.RED.dark,
	},
	
	errorText: {
		color: colorList.RED.dark,
		fontSize: 14,
	},
	
	
	textInput: {
		backgroundColor: colorList.WHITE.primary,
		fontSize: 15,
	},
	textAccessoryRight: {
		color: colorList.TEXT.light,
		fontSize: 16,
		lineHeight: 20,
		textAlign: 'center',
	},
	domainSuffix: {
		flex: 0,
		alignItems: 'center',
		justifyContent: 'center',
	},
	domainStatusText: {
		color: colorList.TEXT_HINT.primary,
		fontSize: 14,
		marginTop: 8,
	},
	domainContinueButton: {
		width: '100%',
		marginTop: 16,
		backgroundColor: colorList.PRIMARY.dark,
	},
	tokenInput: {
		fontSize: 22,
		letterSpacing: 4,
	},
	spinnerCenter: {
		marginTop: 24,
		flex: 1,
		justifyContent: 'center',
		alignItems: 'center',
		margin: ThemedValues.marginHorizontal
	},
	image: {
		flex: 1,
		resizeMode: "cover",
		justifyContent: "center"
	},
	submitButton: {
		...layoutStyles.bottomButtonContainer,
		paddingHorizontal: 0
	},
	
	
	testWarningTitle: {
		color: colorList.RED.primary,
		fontSize: 12,
		padding: ThemedShared.paddingSmall.padding,
		paddingBottom: 2,
		fontWeight: '700'
	},
	testWarningText: {
		color: colorList.RED.primary,
		fontSize: 11,
		padding: ThemedShared.paddingSmall.padding,
		paddingTop: 0
	},
	
	tokenContainer: {
		// marginTop: 25,
	},
	
	textRow: {
		height: 'auto',
	},
	textCol: {
		paddingLeft: 5,
		paddingRight: 5
	},
	
	buttonResend: {
		justifyContent: "center",
		textAlign: 'center',
		alignItems: 'center',
		width: '100%',
		borderWidth: 1,
		borderColor: colorList.BLACK.primary
	},
	buttonResendCountdown: {
		position: "absolute",
		left: 0,
		right: 0,
		top: 0,
		bottom: 0,
		justifyContent: "center",
		textAlign: 'center',
		alignItems: 'center',
	},
	buttonResendCountdownText: {
		fontWeight: '700',
		color: colorList.WHITE.primary
	},
	
	modVersion: {
		fontSize: 12,
		textAlign: 'center',
		color: colorList.TEXT_HINT.primary,
		marginBottom: 24,
	},
	modVersionUpdate:{
		fontSize: 12,
		textAlign: 'center',
		textDecorationLine: 'underline',
		color: colorList.PRIMARY.dark
	},
	modVersionUpdateProgress: {
		alignItems: 'center',
		paddingTop: 8
	},
	authenticationModeContainer: {
		flexDirection: 'row',
		alignItems: 'flex-start',
		justifyContent: 'flex-start',
	},
	authenticationModeButtonContainer: {
		paddingHorizontal: 0,
		marginRight: 8,
		marginVertical: 8,
		alignItems: 'flex-start'
	},
	authenticationModeButton: {
		width: 96,
		height: 72,
		borderWidth: 1,
		borderRadius: 12,
		borderColor: colorList.GREY.dark,
		justifyContent: "center",
		alignItems: 'center',
		backgroundColor: colorList.WHITE.primary,
	},
	authenticationModeButtonActive: {
		borderColor: colorList.PRIMARY.dark,
		backgroundColor: colorList.ORANGE.subtle,
	},
	
	tokenIconText: {
		fontSize: 24,
		color: colorList.ORANGE.primary
	},
	
	qrCodeContainer: {
		flexDirection: 'row'
	},
	qrCodeContainerCode: {
		alignItems: 'flex-start',
		flex: 1
	},
	qrCodeContainerExplanation: {
		flex: 1
	},
	numberedList: {
		flexDirection: 'row',
		marginBottom: 8,
	},
	numberedListNumber: {
		width: 24,
		flexShrink: 0,
	},
	numberedListText: {
		flex: 1,
		minWidth: 0,
	},
	
	qrContainer: {
		flexDirection: 'column',
		alignItems: 'stretch',
		gap: 20,
	},
	qrItem: {
		flexGrow: 0,
		flexShrink: 0,
		width: '100%',
	},
	qrContainerMobile: {
		flexDirection: 'column',
		alignItems: 'stretch',
		gap: 20,
	},
	qrItemMobile: {
		flex: 0,
		width: '100%',
	},
	qrExplanationMobile: {
		marginTop: 4,
	},
	qrCodeItem: {
		height: 200,
		minHeight: 200,
		flexBasis: 200,
		flexGrow: 0,
		flexShrink: 0,
		alignItems: 'center',
		justifyContent: 'center',
		overflow: 'hidden',
	},

	testFlightContainer: {
		backgroundColor: colorList.WHITE.primary,
		zIndex: 1000,
		position: 'absolute',
		left: 0,
		top: 0,
		right: 0,
		padding: 30,
		paddingTop: 50,
		height: Dimensions.get( 'window' ).height
	},
	
	testFlightTitle: {
		fontWeight: '700',
		fontSize: 20,
		color: colorList.ORANGE.primary
	},
	testFlightVersion: {
		fontWeight: '700',
		fontSize: 20,
		color: colorList.ORANGE.primary,
		marginBottom: 16
	},
	testFlightText: {
		marginBottom: 16
	}
});
